export default {
  resendInviteMsg: 'Resend Invite',
  inviteSentMsg: 'Invite Sent',
};
